<script setup>
const TEAM_ICON_URL = '/images/site/logo-lenta.svg';

const props = defineProps({
  packageEvent: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div
    class="i-package-event-name"
  >
    <div class="i-package-event-name__img">
      <img
        :src="TEAM_ICON_URL"
        alt="Домашняя команда"
      >
    </div>
    <div class="i-package-event-name__wrapper">
      <div class="i-package-event-name__title">
        {{ packageEvent.name }}
      </div>
      <div class="i-package-event-name__nom-name">
        {{ packageEvent.nomName }}
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.i-package-event-name {
  display: flex;
  gap: 8px;

  &__img {
    width: 50px;
    height: 50px;
  }

  &__title {
    font-weight: 700;
    font-size: 18px;
    color: $dark-text;
  }

  &__nom-name {
    font-size: 14px;
    color: $grey-text;
  }
}
</style>
